export function findUniverse(search: string, pathname: string) {
  const paramUniverse = new URLSearchParams(search).get('universe');
  const companyUniverse = pathname.indexOf('company') > 0 || pathname.indexOf('efforts') > 0 ? 'company' : undefined;
  return paramUniverse || companyUniverse;
}
